import { createContext, useContext, useState } from "react";

const SearchContext = createContext();

const initialState = {
  trip_type: "oneway",
  origin: "",
  destination: "",
  departure_date: "",
  return_date: "",
  cabin_class: "business",
  passengers: 1,
  allow_transfer: true,
  card_id: null,
  destination_code: "",
  origin_code: "",
};

export const SearchProvider = ({ children }) => {
  const [formData, setFormData] = useState(initialState);

  return (
    <SearchContext.Provider value={{ formData, setFormData }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => useContext(SearchContext);